import React from 'react';
import { NextPageContext } from 'next';
import { getLogger } from '@sm/logging';

import { FiveHundredErrorPage } from '../source/app/components/Errors/FiveHundredError';

// set up logger
const log = getLogger({ name: 'respweb:pages:ssr-error' });

type RequestId = string | undefined;

type ErrorProps = {
  reqId: RequestId;
};

function Error({ reqId }: ErrorProps): React.ReactElement {
  return <FiveHundredErrorPage requestId={reqId} />;
}

Error.getInitialProps = ({ res, err }: NextPageContext): ErrorProps => {
  // Disabling this because it's the pattern NextJS uses
  // here: https://nextjs.org/docs/pages/building-your-application/routing/custom-error#more-advanced-error-page-customizing
  // eslint-disable-next-line no-nested-ternary
  const statusCode = res?.statusCode ?? err?.statusCode ?? 500;
  const reqId = res?.getHeader('sm-request-id') as RequestId;
  log?.error({
    error: err,
    url: res?.req.url,
    reqId,
    msg: `Error on server side rendering. Status code sent: ${statusCode}`,
  });
  return { reqId };
};

export default Error;
